import React, { Component } from 'react';
import { Form, message, Row, Tabs } from 'antd';
import {
  queryMaterialReturnListBRDone,
  queryMaterialReturnListBRTodo,
  querySaveMaterialReturn,
} from '@api/administrative/material';
import '../../expenses.less';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import ModalReturn from './ModalReturn';
import FormSearch from '../../FormSearch';
import TableExpenses from './TableExpenses';

const { TabPane } = Tabs;

class PageManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      TodoDataSource: {
        list: [],
        pagination: {},
      },
      DoneDataSource: {
        list: [],
        pagination: {},
      },
      returnVisible: false,
      returnData: {},
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.route.path) {
      backInfo.start && backInfo.limit && (this.current = backInfo.start);
      backInfo.start &&
        backInfo.limit &&
        (this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        });

      backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
      backInfo.condition && (this.searchCondition.condition = backInfo.condition);
      backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.route.path,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  setTodoData = res => {
    this.setState({
      TodoDataSource: {
        list: res.data,
        pagination: {
          total: res.totalSize,
          pageSize: 15,
          current: this.current,
        },
      },
    });
  };

  setTableDoneData = res => {
    this.setState({
      DoneDataSource: {
        list: res.data,
        pagination: {
          total: res.totalSize,
          pageSize: 15,
          current: this.current,
        },
      },
    });
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  handleChange = val => {
    this.type = val;
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getMaterialReturnListBRTodo = params => {
    queryMaterialReturnListBRTodo(params).then(res => {
      if (res.statusCode === 200) {
        this.setTodoData(res);
      }
    });
  };

  getMaterialReturnListBRDone = params => {
    queryMaterialReturnListBRDone(params).then(res => {
      if (res.statusCode === 200) {
        this.setTableDoneData(res);
      }
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getMaterialReturnListBRTodo(params);
    this.getMaterialReturnListBRDone(params);
  };

  // 资料借还
  showModalReturn = data => {
    this.setState({ returnData: data, returnVisible: true });
  };

  handleReturnCancel = () => {
    this.setState({ returnVisible: false });
  };

  handleSaveReturn = data => {
    const params = data;
    querySaveMaterialReturn(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message, 2.5);
        this.handleReturnCancel();
      } else {
        message.error(res.message, 2.5);
        this.handleReturnCancel();
      }
    });
  };

  render() {
    const { TodoDataSource, DoneDataSource, returnVisible, returnData } = this.state;
    const TodoParentProps = {
      type: 'todo',
      type2: 'mine',
      dataSource: TodoDataSource,
      onChange: this.handleTableChange,
      showModalReturn: this.showModalReturn,
    };
    const DoneParentProps = {
      type: 'done',
      type2: 'mine',
      dataSource: DoneDataSource,
      onChange: this.handleTableChange,
      showModalReturn: this.showModalReturn,
    };
    return (
      <div>
        <Row>
          <FormSearch
            onChange={this.handleChange}
            onSearch={this.handleSearch}
            {...this.searchCondition}
          />
        </Row>
        <Tabs>
          <TabPane tab="待归还" key="1">
            <div id="ant-small-table">
              <TableExpenses {...TodoParentProps} />
            </div>
          </TabPane>
          <TabPane tab="已完成" key="2">
            <div id="ant-small-table">
              <TableExpenses {...DoneParentProps} />
            </div>
          </TabPane>
        </Tabs>

        <ModalReturn
          data={returnData}
          visible={returnVisible}
          handleOk={this.handleSaveReturn}
          handleCancel={this.handleReturnCancel}
        />
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create({ wrappedComponentRef: true })(PageManage));



// WEBPACK FOOTER //
// ./src/components/administrative/material/return/PageMine.js